import { useContext, useMemo } from "react";
import { useAggregatedProductInfo } from "./api/use-aggregated-product-info";
import { SettingsContext } from "../../contexts/settings";

export const useShipmentProductFeatures = (id, shipmentProductKey) => {
    const { settings } = useContext(SettingsContext);
    const { data: details } = useAggregatedProductInfo(shipmentProductKey);
    const shipmentProductFeatures = details?.shipmentProductFeatures;
    const isFeatureActive = settings.intakeConfigFeatures[id]?.isActive;

    return useMemo(() => {
        const productFeature = shipmentProductFeatures?.find((product) => product.id === id);

        return {
            featureName: isFeatureActive ? productFeature?.name : "",
            productHasFeature: isFeatureActive && !!productFeature,
            isFeatureActive,
        };
    }, [shipmentProductFeatures, isFeatureActive, id]);
};
